import Vue from 'vue'
import Router from 'vue-router'




Vue.use(Router)

//superAdmin
import superAdminHome from '../pages/superAdmin/Home.vue';
import superAdminIndex from '../pages/superAdmin/Full.vue';
import superAdminLogin from '../pages/superAdmin/Login.vue';
import superAdminMainStore from '../pages/superAdmin/MainStore.vue';
import superAdminSystemActive from '../pages/superAdmin/Active.vue';
import superAdminOrders from '../pages/superAdmin/Orders.vue';
import superAdminOrderGoodsStat from '../pages/superAdmin/OrderGoodsStat.vue';
import superAdminOrderDetail from '../pages/superAdmin/OrderDetail.vue';

//mainStore
import mainStoreHome from '../pages/mainStore/Home.vue';
import mainStoreIndex from '../pages/mainStore/Full.vue';
import mainStoreLogin from '../pages/mainStore/Login.vue';
import mainStoreStore from '../pages/mainStore/Store.vue';
import mainStoreOrder from '../pages/mainStore/Orders.vue';
import mainStoreOrderDetail from '../pages/mainStore/OrderDetail.vue';
import mainStoreOrderGoodsStat from '../pages/mainStore/OrderGoodsStat.vue';


import mainStoreStorePlugins from '../pages/mainStore/StorePlugins.vue';
import mainStoreUser from '../pages/mainStore/StoreUser.vue';
import mainStoreRoles from '../pages/mainStore/Roles';
import mainStoreStoreSetting from '../pages/mainStore/StoreSetting.vue';
import mainStoreStoreH5Config from '../pages/mainStore/StoreH5Config.vue';



//store
import storeIndex from '../pages/store/Full.vue';
import storeLogin from '../pages/store/Login.vue';
import storeGoodsTag from '../pages/store/GoodsTag.vue';
import storeGoodsGroups from '../pages/store/GoodsGroups.vue';

import storeUserCardLogs from '../pages/store/components/UserCardLogs.vue';

import storeGoods from '../pages/store/Goods.vue';
import storePrinterDataModel from '../pages/store/PrinterDataModel.vue';
import storePrinter from '../pages/store/Printer.vue';
import storePrinterLogs from '../pages/store/PrinterStatusLogs.vue';

import storePrinterHistory from '../pages/store/PrinterLogs.vue';


import storeStoreUser from '../pages/store/StoreUser.vue';

import storeTable from '../pages/store/Tables.vue';
import storeOrder from '../pages/store/Orders.vue';

import storeOrderGoodsStat from '../pages/store/OrderGoodsStat.vue';

import storeSetting from '../pages/store/Setting.vue';
import storeOrderDetail from '../pages/store/OrderDetail.vue';
import storeH5Config from '../pages/store/H5Config.vue';

import storePluginsStore from '../pages/store/Plugins.vue';
import storeCallTag from '../pages/store/CallTag.vue';

import storeCallLog from '../pages/store/CallLog.vue';

import coupons from '../pages/store/Coupons.vue';
import couponUrls from '../pages/store/CouponUrls.vue';
import couponCode from '../pages/store/CouponCodes.vue';



import storeChargeItem from '../pages/store/ChargeItem.vue';

import storeConsumer from '../pages/store/Consumer.vue';
import storeConsumerDetail from '../pages/store/ConsumerDetail.vue';


import storeRoles from '../pages/store/Roles.vue';
import storeHome from '../pages/store/Home.vue';

import storeQueueUpGroup from '../pages/store/TableQueueUpGroups.vue';
import storeMakeQueue from '../pages/store/MakeQueue.vue';

import storeQueueUp from '../pages/store/QueueUp.vue';

import snsTemplateNodes from '../pages/store/SnsTemplateNodes.vue';


export default new Router({
  routes: [

    //superAdmin
    {path: '/superAdmin/login', name: '登录', component: superAdminLogin},
    {path: '/superAdmin/index', name: '餐饮', component: superAdminIndex,
      children: [
        {
          path: '/',
          component: superAdminHome,
          meta: [
            {name:'仪表盘',path:'/superAdmin/home'},
          ],
        },
        {
          path: '/superAdmin/home',
          component: superAdminHome,
          meta: [
            {name:'仪表盘',path:'/superAdmin/home'},
          ],
        },
        {
          path: '/superAdmin/mainStore',
          component: superAdminMainStore,
          meta: [
            {name:'店家管理',path:'/superAdmin/mainStore'},
          ],
        },
        {
          path: '/superAdmin/orders',
          component: superAdminOrders,
          meta: [
            {name:'订单列表',path:'/superAdmin/orders'},
          ],
        },
        {
          path: '/superAdmin/orderDetail',
          component: superAdminOrderDetail,
          meta: [
            {name:'订单列表',path:'/superAdmin/orders'},
            {name:'订单详情',path:'/superAdmin/orderDetail'},
          ],
        },
        {
          path: '/superAdmin/orderGoodsStat',
          component: superAdminOrderGoodsStat,
          meta: [
            {name:'订单菜品统计',path:'/superAdmin/orderGoodsStat'},
          ],
        },

        {
          path: '/superAdmin/active',
          component: superAdminSystemActive,
          meta: [
            {name:'激活系统',path:'/superAdmin/active'},
          ],
        },

      ]
    },


    //mainStore
    {path: '/mainStore/login', name: '登录', component: mainStoreLogin},
    {path: '/mainStore/index', name: '餐饮', component: mainStoreIndex,
      children: [
        {
          path: '/',
          component: mainStoreHome,
          meta: [
            {name:'仪表盘',path:'/mainStore/home'},
          ],
        },
        {
          path: '/mainStore/home',
          component: mainStoreHome,
          meta: [
            {name:'仪表盘',path:'/mainStore/home'},
          ],
        },
        {
          path: '/mainStore/store',
          component: mainStoreStore,
          meta: [
            {name:'门店管理',path:'/mainStore/store'},
          ],
        },
        {
          path: '/mainStore/orders',
          component: mainStoreOrder,
          meta: [
            {name:'订单列表',path:'/mainStore/orders'},
          ],
        },
        {
          path: '/mainStore/orderDetail',
          component: mainStoreOrderDetail,
          meta: [
            {name:'订单列表',path:'/mainStore/orders'},
            {name:'订单详情',path:'/mainStore/orderDetail'},
          ],
        },
        {
          path: '/mainStore/orderGoodsStat',
          component: mainStoreOrderGoodsStat,
          meta: [
            {name:'订单菜品统计',path:'/mainStore/orderGoodsStat'},
          ],
        },
        {
          path: '/mainStore/store/plugins',
          component: mainStoreStorePlugins,
          meta: [
            {name:'门店管理',path:'/mainStore/store'},
            {name:'门店插件',path:'/mainStore/store/plugins'},
          ],
        },
        {
          path: '/mainStore/user',
          component: mainStoreUser,
          meta: [
            {name:'员工管理',path:'/mainStore/user'},
          ],
        },
        {
          path: '/mainStore/roles',
          component: mainStoreRoles,
          meta: [
            {name:'权限管理',path:'/mainStore/roles'},
          ],
        },
        {
          path: '/mainStore/store/setting',
          component: mainStoreStoreSetting,
          meta: [
            {name:'门店管理',path:'/mainStore/store'},
            {name:'门店配置',path:'/mainStore/store/setting'},
          ],
        },
        {
          path: '/mainStore/store/h5_config',
          component: mainStoreStoreH5Config,
          meta: [
            {name:'门店管理',path:'/mainStore/store'},
            {name:'主题管理',path:'/mainStore/store/h5_config'},
          ],
        },


      ]
    },


    //store
    {path: '/store/login', name: '登录', component: storeLogin},
    {path: '/store/index', name: '餐饮', component: storeIndex,
      children: [
        {
          path: '/',
          component: storeHome,
          meta: [
            {name:'仪表盘',path:'/store/home'},
          ],
        },
        {
          path: '/store/home',
          component: storeHome,
          meta: [
            {name:'仪表盘',path:'/store/home'},
          ],
        },
        {
          path: '/store/coupons',
          component: coupons,
          meta: [
            {name:'优惠券',path:'/store/coupons'},
          ],
        },
        {
          path: '/store/coupon/urls',
          component: couponUrls,
          meta: [
            {name:'领取链接',path:'/store/coupon/urls'},
          ],
        },
        {
          path: '/store/coupon/code',
          component: couponCode,
          meta: [
            {name:'兑换码',path:'/store/coupon/code'},
          ],
        },
        {
          path: '/store/goodsTag',
          component: storeGoodsTag,
          meta: [
            {name:'菜品标签',path:'/store/goodsTag'},
          ],
        },
        {
          path: '/store/goods',
          component: storeGoods,
          meta: [
            {name:'菜品',path:'/store/goods'},
          ],
        },
        {
          path: '/store/goodsGroups',
          component: storeGoodsGroups,
          meta: [
            {name:'菜品分组',path:'/store/goodsGroups'},
          ],
        },
        {
          path: '/store/printerDataModel',
          component: storePrinterDataModel,
          meta: [
            {name:'打印模板配置',path:'/store/printerDataModel'},
          ],
        },
        {
          path: '/store/printer',
          component: storePrinter,
          meta: [
            {name:'打印机管理',path:'/store/printer'},
          ],
        },
        {
          path: '/store/printer/logs',
          component: storePrinterLogs,
          meta: [
            {name:'打印日志',path:'/store/printer/logs'},
          ],
        },
        {
          path: '/store/printer/history',
          component: storePrinterHistory,
          meta: [
            {name:'打印日志',path:'/store/printer/history'},
          ],
        },
        {
          path: '/store/storeUser',
          component: storeStoreUser,
          meta: [
            {name:'店员管理',path:'/store/storeUser'},
          ],
        },
        {
          path: '/store/storeRoles',
          component: storeRoles,
          meta: [
            {name:'角色管理',path:'/store/storeRoles'},
          ],
        },

        {
          path: '/store/tables',
          component: storeTable,
          meta: [
            {name:'餐桌管理',path:'/store/tables'},
          ],
        },
        {
          path: '/store/orders',
          component: storeOrder,
          meta: [
            {name:'订单列表',path:'/store/orders'},
          ],
        },
        {
          path: '/store/orderDetail',
          component: storeOrderDetail,
          meta: [
            {name:'订单列表',path:'/store/orders'},
            {name:'订单详情',path:'/store/orderDetail'},
          ],
        },
        {
          path: '/store/orderGoodsStat',
          component: storeOrderGoodsStat,
          meta: [
            {name:'订单菜品统计',path:'/store/orderGoodsStat'},
          ],
        },
        {
          path: '/store/setting',
          component: storeSetting,
          meta: [
            {name:'系统设置',path:'/store/setting'},
          ],
        },

        {
          path: '/store/h5Config',
          component: storeH5Config,
          meta: [
            {name:'主题管理',path:'/store/h5Config'},
          ],
        },
        {
          path: '/store/pluginsStore',
          component: storePluginsStore,
          meta: [
            {name:'插件市场',path:'/store/pluginsStore'},
          ],
        },
        {
          path: '/store/callTag',
          component: storeCallTag,
          meta: [
            {name:'呼叫服务',path:'/store/callTag'},
          ],
        },
        {
          path: '/store/callLog',
          component: storeCallLog,
          meta: [
            {name:'呼叫记录',path:'/store/callLog'},
          ],
        },
        {
          path: '/store/sns/nodes',
          component: snsTemplateNodes,
          meta: [
            {name:'短信模板',path:'/store/sns/nodes'},
          ],
        },

        {
          path: '/store/chargeItem',
          component: storeChargeItem,
          meta: [
            {name:'充值项配置',path:'/store/chargeItem'},
          ],
        },
        {
          path: '/store/consumer',
          component: storeConsumer,
          meta: [
            {name:'会员管理',path:'/store/consumer'},
          ],
        },
        {
          path: '/store/consumer/detail',
          component: storeConsumerDetail,
          meta: [
            {name:'会员管理',path:'/store/consumer'},
            {name:'会员详情',path:'/store/consumer/detail'},
          ],
        },

        {
          path: '/store/userCardLogs',
          component: storeUserCardLogs,
          meta: [
            {name:'会员管理',path:'/store/consumer'},
            {name:'会员详情',path:'/store/consumer/detail'},
            {name:'会员记录',path:'/store/userCardLogs'},
          ],
        },
        {
          path: '/store/queue_up_group',
          component: storeQueueUpGroup,
          meta: [
            {name:'排队分组',path:'/store/queue_up_group'},
          ],
        },
        {
          path: '/store/make_queue',
          component: storeMakeQueue,
          meta: [
            {name:'制作队列',path:'/store/make_queue'},
          ],
        },
        {
          path: '/store/queue_up',
          component: storeQueueUp,
          meta: [
            {name:'排队分组',path:'/store/queue_up_group'},
            {name:'排队管理',path:'/store/queue_up'},
          ],


        },
      ]
    },

    {path: '/', name: '登录', component: storeLogin},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js